import React from "react";
import { BrandIcon } from "@taskpane/icons";
import { Header } from "@taskpane/components";
import css from "./EmptyScreen.module.scss";

export interface EmptyScreenProps {
  text?: React.ReactNode;
}

const EmptyScreen: React.FC<EmptyScreenProps> = ({ text = "" }) => {
  const attrs = {
    container: {
      className: css.container,
    },
    content: {
      className: css.content,
    },
    icon: {
      className: css.icon,
    },
    text: {
      className: css.text,
    },
  };

  return (
    <div {...attrs.container}>
      <Header />
      <div {...attrs.content}>
        <BrandIcon {...attrs.icon} />
        <div {...attrs.text}>{text}</div>
      </div>
    </div>
  );
};

export default EmptyScreen;
